import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ObjectModel} from './object.model';
import {EMPTY, Observable} from 'rxjs';
import {catchError, shareReplay} from 'rxjs/operators';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {CalcparamModel} from '../calcparam/calcparam.model';
import {ReactiveServiceWithFilters} from '../reactive-service-with-filters.abstract';
import {HierarchyModel} from '../hierarchy/hierarchy.model';



@Injectable()
export class ObjectsApiService extends ReactiveServiceWithFilters implements Resolve<ObjectModel[]> {


  timeout = 160 * 60 * 10000; // 5 минут

  private baseUrl = environment.backEndUrlPrefix + '/' + 'db/object';

  constructor(private http: HttpClient) {
    super();
  }

  loadAll() {
    const timeout = 5 * 60 * 10000;
    const key = 'loadAll';
    const cache = this.getSnapshot(key, timeout);
    if (!cache) {
      this.request(key, this.http.get<ObjectModel[]>(this.baseUrl));
    }
  }

  getAll(filter?: any) {
    if (filter) {
      return this.http.get<ObjectModel[]>(this.baseUrl,
        {params: {
            worstSysStateId: filter.sysParamStates.map(id => String(id)),
            state: filter.objectStates.map(id => String(id)),
            objectTypeId: filter.objectTypes.map(id => String(id)),
            paramTag: filter.labels.map(obj => obj.name),
        }}).pipe(
        shareReplay(1),
        catchError(err => EMPTY));
    }
    return this.http.get<ObjectModel[]>(this.baseUrl).pipe(
      shareReplay(1),
      catchError(err => EMPTY));

  }


  getAllShortest() {
    return this.http.get<ObjectModel[]>(this.baseUrl + '/shortest');
  }

  deleteGroup(ids: number[]) {
    return this.http.delete<string>(this.baseUrl, {params: {id: ids.map(id => String(id))}});
  }

  byRubric(id) {
    return this.http.get<ObjectModel[]>(`${this.baseUrl}/child/objrubric/${id}`);
  }

  byId(object_id): Observable<ObjectModel> {
    return this.http.get<ObjectModel>(this.baseUrl + `/${object_id}`);
  }

  getCDP(object_id, params = {}) {
    return this.http.get<any>(this.baseUrl + `/${object_id}/cdp`, {params});
  }

  getDashboards(object_id, params = {}) {
    return this.http.get<any>(this.baseUrl + `/${object_id}/dashboard`, {params});
  }

  getAttributes(object_id, params = {}) {
    //return this.http.get<any>(this.baseUrl + `/${object_id}/attr`, {params});
    return this.http.get<any>(`${environment.backEndUrlPrefix}/object_attr?objectId=${object_id}`, {params});
  }

  getControllers(object_id, params = {}) {
    return this.http.get<any>(environment.backEndUrlPrefix + `/db/controller/child/object/${object_id}`, {params});
  }

  updateGroup(ids: number[], data): Observable<ObjectModel[]> {
      return this.http.patch<HierarchyModel[]>(this.baseUrl, data, {params: {id: ids.map(id => id.toString())}});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CalcparamModel[]> | Promise<CalcparamModel[]> | CalcparamModel[] {
    return this.getAll();
  }

}
